export { useExternalLinkIcon } from './use-external-link-icon';
